import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastFormSubmissionsHandoff } from '@/pages/workspaces/broadcasts/broadcast/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/form-submissions',
)({
  component: JourneysBroadcastFormSubmissionsHandoff,
});
